module.exports = __webpack_public_path__ + "static/media/18-holes-shot-5.4f7e3d35.jpg";